import i18n from '@/utils/i18n';
import LockIcon from '@assets/icons/lock.svg';
import React from 'react';
import { CollectionOptionType } from '@/hooks/use-collection-list-options';
import { createStyles } from '@/contexts/theme-context';
import { partnerSupplier } from '@/utils/environment';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  option: CollectionOptionType;
}

export const OrderGuideCollectionListItemContent: React.FC<Props> = ({
  option,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.listItemContent}>
      <View style={styles.listItemRow}>
        <Text style={TYPOGRAPHY.listTitle}>{option.title}</Text>
        {option.metadata?.isLocked ? (
          <LockIcon stroke={theme.sk.color.icon.tertiary} />
        ) : null}
      </View>
      {option.metadata?.isDefault ? (
        <Text style={[TYPOGRAPHY.listSubtitle, styles.listItemSubtitleText]}>
          {i18n.t('default')}
        </Text>
      ) : option.metadata?.isLinked || option.metadata?.type === 'supplier' ? (
        <Text style={[TYPOGRAPHY.listSubtitle, styles.listItemSubtitleText]}>
          {i18n.t('supplier_imported', {
            supplierName: partnerSupplier.fullName,
          })}
        </Text>
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  listItemContent: {
    flex: 1,
  },
  listItemRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  listItemSubtitleText: {
    color: theme.sk.color.text.tertiary,
  },
}));
